<template>    
  <v-app>     
    <div style="height:100vh; overflow-y: auto">      
      <v-content>        
        <div id="login" :class="color"></div>
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs11 sm8 md3 lg3>
              <v-card class="elevation-1">
                <v-card-text class="px-3">
                  <div class="layout column align-center">
                    <img src="logo.png" alt="Vue Material Admin" height="80">
                    <h1 class="flex my-2 primary--text">{{$config.title}}</h1>                      
                  </div>                
                  <v-form>
                    <v-text-field append-icon="fa fa-user fa-lg" name="login" label="Login" type="text" v-model="model.username"></v-text-field>
                    <v-text-field hide-details
                      append-icon="fa fa-lock fa-lg" 
                      name="password" 
                      label="Password" 
                      id="password" 
                      v-model="model.password" 
                      @keyup.enter="login"                      
                      :append-icon="show3 ? 'visibility' : 'visibility_off'"                    
                      :type="show3 ? 'text' : 'password'"
                      @click:append="show3 = !show3"                    
                    ></v-text-field>                    
                    <v-text-field class="mt-3" name="captcha" @keyup.enter="login" label="Captcha" type="text" v-model="model.captcha" hide-details>
                      <template slot="append">
                        <v-fade-transition leave-absolute>
                          <v-progress-circular
                            v-if="!captcha"
                            size="24"
                            width="2"
                            color="info"
                            indeterminate
                          ></v-progress-circular>
                          <img class="cursor" @click="getCaptcha()" v-else :src="captcha" alt="">
                        </v-fade-transition>
                      </template>                      
                    </v-text-field>
                    
                  </v-form>
                </v-card-text>
                <v-card-actions class="px-3">
                  <!--<v-btn icon @click="openSetting">
                    <v-icon color="teal">fa-gear</v-icon>
                  </v-btn>-->
                  <v-spacer></v-spacer>
                  <v-btn block color="primary" @click="login" :loading="loading">Login</v-btn>                
                </v-card-actions>                
                <v-card-actions class="mt-3 grey lighten-4">
                  <!--<v-btn icon @click="openSetting">
                    <v-icon color="teal">fa-gear</v-icon>
                  </v-btn>-->
                  <v-btn @click="$router.push({path:'/register'})" flat color="orange">Need new account as saksi ?</v-btn>                            
                  <v-spacer></v-spacer>                  
                </v-card-actions> 
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <widget-dialog-setting></widget-dialog-setting>  
      </v-content>  
    </div>
  </v-app>        
</template>

<script>
import config from '@/config';  
import WidgetDialogSetting from '../components/widgets/DialogSetting';      
import moment from 'moment';    
import Device from '@/util/models/Device';
import User from '@/util/models/User';

export default {
  components: {
    WidgetDialogSetting
  },      
  data: () => ({
    color:config.color,
    loading: false,    
    show3: false,
    captcha:null,
    model: {
      username: '',
      password: '',
      captcha : null
    }
  }),  
  mounted: function(){      
      this.getCaptcha(); 
  },
  methods: {
    getCaptcha(){        
        this.captcha = null;
        User.captcha().then(res=>{            
            if(res.status === 200){                
                this.captcha = res.data;
            }
        });
    },
    
    async login() {
        this.loading = true;
        const response = await User.login(this.model.username, this.model.password, this.model.captcha);        
        if(response.status == 200){        
            this.token = response.data;
            User.set(this.token);            
            window.getApp.$emit('showSnackbar', {
                show:true,
                text:'Login Successfully. Redirecting...',
                color:'green'
            });
        
            setTimeout(() => {this.$router.push('/');}, 1000);
        } else {
            var msg = response.data? '#'+response.data.status+' => '+response.data.message:
                'Something happened in setting up the request that triggered an Error.'; 
            
            window.getApp.$emit('showSnackbar', {
                show:true,
                text: msg,
                color:'red'
            });
        }
        setTimeout(() => {this.loading = false;}, 1000);
    },
    
    openSetting(){
        window.getApp.$emit('APP_OPEN_DIALOG_SETTING');        
    }
  },  
};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
